import { Big } from 'big.js';

export const fromMillisecondsToSeconds = (ms: number | null | undefined) => (
  ms ? Big(ms).div(1_000).toNumber() : ms
);

export const fromSecondsToMilliseconds = (sec: number | null | undefined) => (
  sec ? Big(sec).mul(1_000).toNumber() : sec
);
